import { Controller, useFormContext } from "react-hook-form";
import _ from "lodash";
import CustomTextInput from "../../CustomInput/CustomTextInput";
import { TextInputField } from "../types";

const TextFieldForm = ({ field }: { field: TextInputField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField, fieldState }) => (
          <>
            <CustomTextInput
              label={field.label}
              value={renderField.value || ""}
              disabled={field.disabled as boolean}
              placeholder={field.placeholder}
              type={field.inputType ?? "text"}
              onChange={(e: any) => {
                const val = (e as any).target.value;
                renderField.onChange(val);
                field.onAfterChange?.(val, { setValue, getValues });
              }}
              />
              {fieldState.error && (
                <p className="text-danger" style={{ fontSize: 12 }}>
                  {fieldState.error.message}
                </p>
              )}
          </>
        )}
      />
    </div>
  );
};

export default TextFieldForm;
